__turbopack_context__.v({
  "accent": "EBBHomepage-module__sK0jGG__accent",
  "bookCover": "EBBHomepage-module__sK0jGG__bookCover",
  "bookLink": "EBBHomepage-module__sK0jGG__bookLink",
  "carouselCard": "EBBHomepage-module__sK0jGG__carouselCard",
  "carouselTrack": "EBBHomepage-module__sK0jGG__carouselTrack",
  "carouselWrap": "EBBHomepage-module__sK0jGG__carouselWrap",
  "closing": "EBBHomepage-module__sK0jGG__closing",
  "closingBanner": "EBBHomepage-module__sK0jGG__closingBanner",
  "coralCta": "EBBHomepage-module__sK0jGG__coralCta",
  "ctaRow": "EBBHomepage-module__sK0jGG__ctaRow",
  "deals": "EBBHomepage-module__sK0jGG__deals",
  "dealsSub": "EBBHomepage-module__sK0jGG__dealsSub",
  "dot": "EBBHomepage-module__sK0jGG__dot",
  "dotActive": "EBBHomepage-module__sK0jGG__dotActive",
  "dots": "EBBHomepage-module__sK0jGG__dots",
  "emailInput": "EBBHomepage-module__sK0jGG__emailInput",
  "emailRow": "EBBHomepage-module__sK0jGG__emailRow",
  "feature": "EBBHomepage-module__sK0jGG__feature",
  "featureVisual": "EBBHomepage-module__sK0jGG__featureVisual",
  "features": "EBBHomepage-module__sK0jGG__features",
  "googleWrap": "EBBHomepage-module__sK0jGG__googleWrap",
  "header": "EBBHomepage-module__sK0jGG__header",
  "headerRow": "EBBHomepage-module__sK0jGG__headerRow",
  "headerScrolled": "EBBHomepage-module__sK0jGG__headerScrolled",
  "headerSticky": "EBBHomepage-module__sK0jGG__headerSticky",
  "hero": "EBBHomepage-module__sK0jGG__hero",
  "heroBanner": "EBBHomepage-module__sK0jGG__heroBanner",
  "heroCard": "EBBHomepage-module__sK0jGG__heroCard",
  "loginBtn": "EBBHomepage-module__sK0jGG__loginBtn",
  "logoFallback": "EBBHomepage-module__sK0jGG__logoFallback",
  "logoImage": "EBBHomepage-module__sK0jGG__logoImage",
  "logoWrap": "EBBHomepage-module__sK0jGG__logoWrap",
  "orDivider": "EBBHomepage-module__sK0jGG__orDivider",
  "page": "EBBHomepage-module__sK0jGG__page",
  "pointImage": "EBBHomepage-module__sK0jGG__pointImage",
  "priceBadge": "EBBHomepage-module__sK0jGG__priceBadge",
  "retailerLogos": "EBBHomepage-module__sK0jGG__retailerLogos",
  "signupError": "EBBHomepage-module__sK0jGG__signupError",
  "signupForm": "EBBHomepage-module__sK0jGG__signupForm",
  "signupForm_closing": "EBBHomepage-module__sK0jGG__signupForm_closing",
  "signupForm_modal": "EBBHomepage-module__sK0jGG__signupForm_modal",
  "signupForm_sticky": "EBBHomepage-module__sK0jGG__signupForm_sticky",
  "signupModalHeadline": "EBBHomepage-module__sK0jGG__signupModalHeadline",
  "signupModalShell": "EBBHomepage-module__sK0jGG__signupModalShell",
  "srOnly": "EBBHomepage-module__sK0jGG__srOnly",
  "starImage": "EBBHomepage-module__sK0jGG__starImage",
  "stars": "EBBHomepage-module__sK0jGG__stars",
  "startReadingBtn": "EBBHomepage-module__sK0jGG__startReadingBtn",
  "stickyDesktopForm": "EBBHomepage-module__sK0jGG__stickyDesktopForm",
  "stickyHeadline": "EBBHomepage-module__sK0jGG__stickyHeadline",
  "stickyMobileCta": "EBBHomepage-module__sK0jGG__stickyMobileCta",
  "stickySignup": "EBBHomepage-module__sK0jGG__stickySignup",
  "stickySignupInner": "EBBHomepage-module__sK0jGG__stickySignupInner",
  "stickySignupOpen": "EBBHomepage-module__sK0jGG__stickySignupOpen",
  "testimonialCard": "EBBHomepage-module__sK0jGG__testimonialCard",
  "testimonials": "EBBHomepage-module__sK0jGG__testimonials",
  "testimonialsDesktop": "EBBHomepage-module__sK0jGG__testimonialsDesktop",
  "testimonialsMobile": "EBBHomepage-module__sK0jGG__testimonialsMobile",
});
